import createNamespaceContext from './helper/createNamespaceContext';
export var TOWNSQUARE_HOME_CONTEXT = 'townsquareHomeCtx';
export var TownsquareHomeAnalyticsContext = createNamespaceContext(TOWNSQUARE_HOME_CONTEXT, 'TownsquareHomeAnalyticsContext');